module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h2', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Chapter One")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Macadamized Mind")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_c('b', [_vm._v("WE MAY THINK ")])]), _vm._v("that the digital era introduces fundamentally new dynamics to the media ecosystem. In many ways, however, digital technologies have simply amplified the dynamics created by the industrial revolution: it was steam power, not binary code, that birthed the modern news industry. One of the most prescient prophets who warned about the effects of this dangerous abundance of news and entertainment was Henry David Thoreau. The popular caricature of Thoreau as a hermit fails to recognize his deep commitment to justice and to understanding the conditions necessary for a healthy political order. In both "), _c('i', [_vm._v("Walden")]), _vm._v(" and, even more astutely, his later essay “Life Without Principle,” Thoreau diagnoses the diseases to which those who follow the news too closely are prone.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thoreau warns that the increased abundance and speed of the news threaten to fragment our attention and damage our ability to see what is really happening and to think rightly about these events. As Josef Pieper puts it, in making a parallel argument, “The average person of our time loses the ability to see because "), _c('i', [_vm._v("there is too much to see!")]), _vm._v("”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-010",
      "id": "ap_ntb-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Even worse, when so many voices vie for our attention, they have to get louder and more sensational to gain a hearing; fake news, sensationalized headlines that today would be labeled “clickbait,” and yellow "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("journalism all developed in the nineteenth century."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-011",
      "id": "ap_ntb-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" In response to this unhealthy environment, Thoreau devoted his attention to what he called “the Eternities” and cautioned against the dangers of being swept up in the flurry created by the news industry. In particular, I’ll enumerate three symptoms Thoreau thinks result from this fragmented attention—what he calls a “macadamized” intellect. First, it induces a vague, underlying sense of boredom and dis-ease, what he terms a mental “dyspepsia.” Second, it renders us vulnerable to the wiles of advertisers and politicians. And third, it warps our emotional sensibilities, directing them toward distant, spectacular events and making it more difficult for us to sympathize with and love our neighbors.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Before we get to Thoreau’s diagnosis, though, we need a bit of context about the technological changes he experienced. The printing presses used in colonial America were not much different from the one that Gutenberg used in fifteenth-century Germany, but between 1800 and 1840 printing technology advanced rapidly: first came iron presses, then the steam-powered Adams press and steam-powered rotary presses, then stereotyping and electrotyping. Alongside these improvements, steam-powered paper mills and new methods of producing paper from wood fiber dramatically decreased the cost of paper."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-012",
      "id": "ap_ntb-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Furthermore, other nineteenth-century technologies "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("transformed the nation’s communication infrastructure: the telegraph, the railroad, and photography shrank the world dramatically. Indeed, the difference between words printed by hand and carried by horse or sail and words printed by steam and carried by wires or rails may well be as vast as the difference between nineteenth-century technologies and twenty-first-century digital technologies.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Visitors to the 1876 Centennial Exhibition in Philadelphia had a vivid display of these technological improvements. In a speech given to the American Book Trade Association, which held its annual meeting in conjunction with the exhibition, the chairman of the reception committee highlighted a display in Machinery Hall. There, visitors could see")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("the old printing-press of Franklin, upon which, by hard labor he could produce perhaps 150 impressions per hour, side by side with the Messrs. Hoe & Co.’s latest invention, the Web perfecting-press, printing 32,000 copies of a newspaper, on both sides, in the same time. . . . Steam, the telegraph, and the power printing-press, what have they not accomplished, and how have they changed the condition of the civilized world!"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-013",
      "id": "ap_ntb-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("A 42,666 percent increase in efficiency is quite remarkable, and those who lived through these changes acutely felt this disruptive power.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("These technological developments—and the economic shifts they made possible—led to the kind of news-as-spectacle that is so prevalent today. As Neil Postman argues, these nineteenth-century technologies ushered in “the Age of Show Business.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-014",
      "id": "ap_ntb-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" At times Postman evinces a naive confidence in the unalloyed goods of print, but he recognizes that these industrial technologies mark an important inflection point. And in the wake of these changes, more and more Americans came to realize that technological advances don’t necessarily foster moral growth; in fact, they can introduce new temptations and dangers.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Macadamizing Process")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It was in this context that Thoreau wrote his lecture “Life Without Principle” as a sort of follow-up to "), _c('i', [_vm._v("Walden")]), _vm._v(". He gave versions of it repeatedly over the last decade of his life, and it was published posthumously in the "), _c('i', [_vm._v("Atlantic")]), _vm._v(". The lecture is a critique of industrial standards of value, and Thoreau invites his hearers to “consider the way in which we spend our lives,” measuring our lives not by quantitative or monetary standards but by whether we live up to our stated principles."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-015",
      "id": "ap_ntb-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" The lecture’s second half in particular focuses on how we spend our attention, and Thoreau pulls no punches in describing the dangers that the industrialized news industry poses to a principled life.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Drawing on biblical imagery, Thoreau warns his hearers that newspapers can become idols. An obsession with the distractions of the daily paper can reveal an inattention—even an infidelity—to the ongoing work of the Creator. As Thoreau puts it,")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("I do not know but it is too much to read one newspaper a week. I have tried it recently, and for so long it seems to me that I have not dwelt in my native region. The sun, the clouds, the snow, the trees say not so much to me. You cannot serve two masters. It requires more than a day’s devotion to know and to possess the wealth of a day."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-016",
      "id": "ap_ntb-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Thoreau then moves from Jesus’ warning against serving mammon (Mt 6:24 KJV) to Paul’s sermon at the Areopagus where he tells the Athenians to stop worshiping idols and instead serve God because “in him we live and move and have our being” (Acts 17:28). Thoreau claims that the news competes with this God, offering an alternative, secular ground of being: “If you chance to live and move and have your being in that thin stratum in which the events that make the news transpire—thinner than the paper on which it is printed—then these things will fill the world for you; but if you soar above or dive below that plane, you cannot remember nor be reminded of them.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-017",
      "id": "ap_ntb-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" What we attend to reveals and shapes our loves, so if our attention is fixed on the thin stratum of the daily news, then we are guilty of a kind of idolatry, of misdirecting our love and even worship. Thoreau’s warning against idolatry is seconded by Simone Weil, an early twentieth-century French polymath and mystic, who claims “the habit of . . . attention . . . is the substance of prayer.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-018",
      "id": "ap_ntb-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This link between attention and worship or love may seem tenuous, but as the etymology of the word suggests, "), _c('i', [_vm._v("attention")]), _vm._v(" entails a deep mutuality or reciprocity that is at the root of love. To attend to something means literally “to stretch toward” it. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("The English words "), _c('i', [_vm._v("tension")]), _vm._v(", "), _c('i', [_vm._v("tune")]), _vm._v(", and "), _c('i', [_vm._v("tend")]), _vm._v(" all come from the same Indo-European root meaning “to stretch.” "), _c('i', [_vm._v("Tend")]), _vm._v(" itself carries a dual meaning that speaks to the nuances embedded in this notion of stretching: “to tend” means both to move toward something, a tendency, and to care for something, to tend a garden, say. So "), _c('i', [_vm._v("attention")]), _vm._v(" signifies a relation stretched between two different things. And embedded in the connotations of these related words—to tend to another or to be in tune with another—is the suggestion of propriety in this stretching. When attention is exercised properly, a certain harmonious resonance comes into existence. So while attention maintains a difference between subject and object, we do tend to become more like that which we attend to: we become what we love."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-019",
      "id": "ap_ntb-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" It is impossible, then, to attend deeply to something and not be changed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-020",
      "id": "ap_ntb-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])])]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-003"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Figure 1.1. The First Macadam Road, 1823, by Carl Rakeman",
      "src": "images/4186_1.1_1823_FIRST_AMERICAN_MACADAM.jpg"
    }
  })]), _vm._v(" "), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Figure 1.1.")]), _vm._v(" "), _c('i', [_vm._v("The First Macadam Road")]), _vm._v(", 1823, by Carl Rakeman")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is this transformative power of attention that leads Thoreau to a startling and profound metaphor. He claims that attending to the trivia of the news "), _c('i', [_vm._v("macadamizes ")]), _vm._v("our intellect. This is a term for a method of road construction named after its inventor, John McAdam, a Scottish engineer. While most roads were built on a foundation of large stones, McAdam used small, hand-broken stones to surface roads; supervisors actually measured the stones to be sure that no large ones slipped through. The angular edges of these rocks would bind together and form a smooth, long-lasting surface for traffic. McAdam’s name lives on today in the word "), _c('i', [_vm._v("tarmac")]), _vm._v(", which refers to macadam roads that were sprayed with tar to cut the dust. With that bit of background, here’s Thoreau’s description of how patterns of attention can alter our minds:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("I believe that the mind can be permanently profaned by the habit of attending to trivial things, so that all our thoughts shall be tinged with triviality. Our very intellect shall be macadamized, as it were—its foundation broken into fragments for the wheels of travel to roll over; and if you would know what will make the most durable pavement, surpassing rolled stones, spruce blocks, and asphaltum, you have only to look into some of our minds which have been subjected to this treatment so long."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-021",
      "id": "ap_ntb-021-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Thoreau weaves together several key terms in these two sentences. To begin with, "), _c('i', [_vm._v("profaned")]), _vm._v(" compares our minds to temples. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_c('i', [_vm._v("Fane")]), _vm._v(" is the Latin word for “temple,” so "), _c('i', [_vm._v("profane")]), _vm._v(" literally means “before or outside the temple.” When we attend too closely to secular, temporal affairs, we “desecrate” our minds. Hence Thoreau goes on to say in the following sentence that we should “make once more a fane of the mind.” There are lasting, even eternal, consequences for what we give our attention to. This is why Paul instructs the Colossians to “set your minds on things that are above, not on things that are on earth” (Col 3:2).")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Habit")]), _vm._v(" emphasizes the repetitive, formative nature of attention. Thoreau’s life and writings certainly demonstrate his own knowledge of contemporary events, so he’s not advocating that we hole ourselves up and ignore everything that’s going on around us."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-022",
      "id": "ap_ntb-022-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" After all, Thoreau himself helped runaway slaves, participated in abolitionist movements, and spent a night in jail over his refusal to pay a tax that would have helped fund the Mexican-American War. Such social engagement flowed not from an obsession with the news of the day but from his commitment to eternal, moral truths. Thus Thoreau is urging us to reflect on our habits, our patterns of attention that shape and fill our minds. What does our daily reading look like? What do we turn to when we’re bored? These are the habits of attention that shape our souls.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Trivia")]), _vm._v(" is of course an indictment of the frivolous affairs that populate the news, but this word also continues Thoreau’s road metaphor. "), _c('i', [_vm._v("Trivia")]), _vm._v(" comes from a Latin word meaning “an intersection of three roads,” so by implication it refers to a place that "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("is well traveled. In English, it came to refer to things that were common, well known, and hence insignificant. Thoreau nods to these roots when he writes earlier in this paragraph, “If I am to be a thoroughfare, I prefer that it be of the mountain-brooks, the Parnassian streams, and not the town-sewers.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-023",
      "id": "ap_ntb-023-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Thoreau imagines our minds as conduits or roadways for ideas, and we are responsible to choose what we want rolling down these streets. Yet, when we habitually attend to trivial things, our minds turn into gravel and become susceptible to whatever ads or slogans or memes other people send spinning down our macadamized intellects.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In his lecture, Thoreau goes on to propose a two-part remedy for this condition:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("If we have thus desecrated ourselves,—as who has not?—the remedy will be by wariness and devotion to reconsecrate ourselves, and make once more a fane of the mind. We should treat our minds, that is, ourselves, as innocent and ingenuous children, whose guardians we are, and be careful what objects and what subjects we thrust on their attention. Read not the Times. Read the Eternities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-024",
      "id": "ap_ntb-024-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As Thoreau acknowledges, we have all, to one degree or another, desecrated our minds by attending to trivia, but Thoreau hopes that by (1) wariness and (2) devotion we can reconsecrate our minds and make them into temples or fanes again. If the problem is habitual attention to things outside the temple, the solution is habitual attention to things inside the temple. This is a two-part movement: it’s a movement away from the gossip and trivia of the Times and a movement toward the good, beautiful, complex truth of the Eternities.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("Again, despite his strident rhetoric here, Thoreau is not advocating absolute withdrawal from the affairs of time. This is not a head-in-the-sand denialism. Rather, Thoreau insists that insofar as we are formed by the ephemeral dramas and scandals of the daily news, we will be unable to contribute meaningfully and redemptively to the real issues and concerns of our times. We will simply be passive highways for the trends and outrage that populate our news feeds.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("While Thoreau didn’t have twenty-first-century research about the brain to support his claims that our habits of attention have long-lasting effects, recent scholarship backs up his metaphor. As we become increasingly embedded in an “ecosystem of interruption technologies” that fosters a state of “continuous partial attention,” our neural networks are actually being restructured."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-025",
      "id": "ap_ntb-025-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Books like Susan Greenfield’s "), _c('i', [_vm._v("Mind Change: How Digital Technologies Are Leaving Their Mark on Our Brains")]), _vm._v(" and Nicholas Carr’s "), _c('i', [_vm._v("The Shallows: What the Internet Is Doing to Our Brains ")]), _vm._v("chart the work of neuroscientists who are discovering the incredible plasticity of our brains."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-026",
      "id": "ap_ntb-026-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" We can indeed macadamize our intellects by attending to trivia. In the "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap2#chap-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("next chapter")]), _vm._v(", we’ll flesh out the contours of the healthier posture Thoreau recommends, but in the remainder of this chapter I’ll examine in a bit more detail three effects or symptoms of a macadamized mind.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Mental Dyspepsia")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("At the conclusion of “Life Without Principle,” Thoreau shifts metaphorical registers and compares the act of attention to that of eating. If we attend to unhealthy news, we—as both individuals and communities—can get a kind of indigestion:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Those things which now most engage the attention of men, as politics and the daily routine, are, it is true, vital functions of human society, but should be unconsciously performed, like the corresponding functions of the physical body. . . . Not only individuals, but States, have thus a confirmed dyspepsia, which expresses itself, you can imagine by what sort of eloquence. Thus our life is not altogether a forgetting, but also, alas! to a great extent, a remembering, of that which we should never have been conscious of, certainly not in our waking hours."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-027",
      "id": "ap_ntb-027-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Thoreau’s vivid imagery—or perhaps I should say his pungent olfactory description—conveys the dangers of indiscriminate consumption of the news. An unhealthy mental diet results in a kind of intellectual bloating and discomfort, and the problem is further compounded because such a diet intensifies our craving for mental junk food. This is not just an individual problem; Thoreau points out that states too can suffer the dyspeptic effects of fragmented attention. Politics in the age of Twitter bears out his warnings.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thoreau calls this disordered intellectual appetite "), _c('i', [_vm._v("curiosity")]), _vm._v(". It’s analogous to a craving for snacks that are salty or sweet but lack real nutrition. And the more we give in to this craving, the less we are able to resist it: “In proportion as our inward life fails, we go more constantly and desperately to the post-office. . . . In health we have not the least curiosity "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("about such events. We do not live for idle amusement. I would not run round a corner to see the world blow up.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-028",
      "id": "ap_ntb-028-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Attending to titillating ephemera creates a vicious cycle as our “inward life fails” and we become further enslaved to the whims of our curiosity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-029",
      "id": "ap_ntb-029-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is this disordered appetite that explains why we watch cat videos on YouTube and share memes on Facebook when we have access to what Thoreau calls “the treasured wealth of the world.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-030",
      "id": "ap_ntb-030-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" This is why more people take "), _c('i', [_vm._v("BuzzFeed")]), _vm._v(" quizzes than read long-form essays in the "), _c('i', [_vm._v("Atlantic")]), _vm._v(". It’s why we itch to check Facebook or Instagram every five minutes. It is always more tempting to eat candy and fast food instead of fresh vegetables from the garden. It’s easier to get an emotional “hit” from shallow, sensational news than it is to spend the mental energy required to engage with more serious matters; watching the world blow up is more exciting than studying its treasured wealth.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is an old problem: humans have always been tempted to rubbernecking and gossip. But just as junk food poses new threats when food engineers find ways to make it maximally addictive, so the news industry preys on our inherent disposition to curiosity through ever more sophisticated techniques. Advanced analytics enable website editors to identify the traits that are likely to make a story go viral, and they use this information to choose what news to cover and to hone clickbait "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("headlines that will entice more revenue-generating clicks."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-031",
      "id": "ap_ntb-031-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" We can’t simply blame journalists for these developments: existential economic pressures lead newsrooms to adopt such tactics, and they wouldn’t be effective if readers demanded more substantive fare.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The irony is that when we succumb to these temptations, we are not satiated. Instead, we get that bloated feeling that has led people to talk about “binging” on Netflix. Thoreau didn’t have streaming TV to critique, so his targets are the “profane and stale revelation of the bar-room and the police court”—he wouldn’t be impressed with "), _c('i', [_vm._v("CSI")]), _vm._v(" and its spinoffs—and the wildly popular sentimental novels."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-032",
      "id": "ap_ntb-032-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" In "), _c('i', [_vm._v("Walden")]), _vm._v(", he upbraids his neighbors who “with saucer eyes, and erect and primitive curiosity, and with unwearied gizzard” gorge themselves on the latest installment from the pen of their favored novelist."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-033",
      "id": "ap_ntb-033-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" “To read well,” Thoreau writes, “is a noble exercise, and one that will task the reader more than any exercise which the customs of the day esteem.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-034",
      "id": "ap_ntb-034-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Hence, he urges his neighbors to feed their minds on a more robust diet than can be found in “the columns of the daily paper.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-035",
      "id": "ap_ntb-035-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thoreau’s rigorous standards can make him seem like a tiresome scold. After all, isn’t there something to be said for unwinding after a long day by watching some TV or scrolling through our news feed? Perhaps, but Thoreau’s dietary metaphor contains an important insight. Some modes of relaxation—much like “comfort food”—actually "), _c('i', [_vm._v("keep")]), _vm._v(" us in a state of bloated exhaustion. The ennui that leads us to binge watch "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("Netflix or mindlessly scroll through a social media feed, looking for easy tidbits of emotional excitement, is a result of overstimulation and indiscriminate news consumption. So, paradoxically, we may be less tired and have more mental energy if we shut up the doors of our fane and discipline our attention.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("An older, Christian term for the kind of appetite that results in this dyspepsia is "), _c('i', [_vm._v("acedia")]), _vm._v(", what the desert fathers called “the noonday devil.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-036",
      "id": "ap_ntb-036-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Acedia manifests as indifference or listlessness regarding substantive, eternal matters—we find it difficult to attend to what we should. So we flit from headline to headline, skimming in search of some new outrage or drama. This condition is the intellectual corollary to what William Cavanaugh describes in writing about the ironies of consumeristic materialism: “What really characterizes consumer culture is not attachment to things but detachment. . . . People do not cling to things; they discard them and buy other things.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-037",
      "id": "ap_ntb-037-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Cavanaugh’s analysis of consumerism needs just a few substituted phrases to apply to the condition of disordered attention: “Our relationships with [news stories] tend to be short-lived: rather than [pondering important developments], consumers are characterized by a constant dissatisfaction with [what they’ve just read]. This dissatisfaction is what produces the restless pursuit of satisfaction in the form of something new.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-038",
      "id": "ap_ntb-038-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" For all our hunger for the next bit of breaking news, we quickly forget it once we’ve extracted the emotional charge it can give us. We "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("are soon hungry for the next outrage, the next unbelievable headline, the next political scandal. We have an intense desire to know "), _c('i', [_vm._v("something")]), _vm._v(", but the object of that desire remains indeterminate and vague. So we scroll hurriedly through our news feed looking for something to latch onto. The desert fathers knew that discipline is the only cure for such a condition, and Thoreau agrees: “By all kinds of traps and sign-boards, threatening the extreme penalty of the divine law, exclude such trespassers from the only ground which can be sacred to you. It is so hard to forget what it is worse than useless to remember!”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-039",
      "id": "ap_ntb-039-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Passive Thoroughfare")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This restless curiosity, this craving for some new bit of entertainment, makes us incredibly vulnerable to the wiles of advertisers and politicians and ideologues. We become susceptible to the latest groupthink because our thoughts are dictated by trending jargon or viral hashtags. To return to Thoreau’s core metaphor, a macadamized mind, an intellect ground to bits and made into a highway offers little resistance to whatever thought or emotion is driven down it. Hence, we become passive thoroughfares, the objects of our attention determined by whatever headlines or memes happen to be going viral.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If our intellects are macadamized, we actually lack the vocabulary or categories to see the world truthfully. We’ll simply take in the events around us through the prepackaged categories provided by the mass media. In his brief essay “Learning How to See Again,” Pieper identifies this problem and asks, “How can man be saved from becoming a totally passive consumer of mass-produced goods and a subservient follower beholden to every slogan the managers may proclaim?” This "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("is a serious challenge because the passive consumer, the subservient follower, “inevitably falls prey to the demagogical spells of any powers that be.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-040",
      "id": "ap_ntb-040-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Pieper’s remedy, which I’ll return to in "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/p1chap3#chap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter three")]), _vm._v(", is to develop an artistic craft, but it’s his acute identification of this problem that is most relevant here.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Hashtags and slogans lack the precision and nuance required to do justice to the complexity of our world and time. If these are the only tools we have, we will be unable to make adequate sense of the news. The agrarian writer Wendell Berry extends Thoreau’s argument in his essay “In Defense of Literacy,” arguing that America’s education system has failed to give students the robust language required to think carefully in a culture that is inundated with persuasive statements urging us to buy this or think that. Berry claims that when we acquiesce to “the doctrine that the purpose of education is the mass production of producers and consumers,” we tend to treat literacy as an ornamental add-on. Berry warns, however, that “we will understand the world, and preserve ourselves and our values in it, only insofar as we have a language that is alert and responsive to it, and careful of it.” He goes on to name our danger precisely: “In our society, which exists in an atmosphere of prepared, public language . . . illiteracy is both a personal and a public danger.” This is because we are “forever being asked to buy or believe somebody else’s line of goods. The line of goods is being sold, moreover, by men who are trained to make him buy it or believe it, whether or not he needs it or understands it or knows its value or wants it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-041",
      "id": "ap_ntb-041-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("An education system that has been co-opted by career "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("training means that more and more of us are unable to navigate what is an increasingly hazardous verbal environment. And our fragmented habits of attention exacerbate this problem: “An unmixed diet” of shallow, transient language,")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("language meant to be replaced by what will immediately follow it, . . . is destructive of the informed, resilient, critical intelligence that the best of our traditions have sought to create and to maintain. . . . Such intelligence does not grow by bloating upon the ephemeral information and misinformation of the public media. It grows by returning again and again to the landmarks of its cultural birthright, the works that have proved worthy of attention."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-042",
      "id": "ap_ntb-042-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is here that Berry cites Thoreau’s prescription: “Read not the Times. Read the Eternities.” Chewing on rich wisdom articulated in careful language feeds our minds and enables us to discern the nuances of the events happening in our time. If we want to exercise more responsibility regarding what ideas we entertain, we will need to develop the attention and vocabulary required to relate truthfully to a complex world. Or, as Berry puts it, “We must speak, and teach our children to speak, a language precise and articulate and lively enough to tell the truth about the world as we know it.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-043",
      "id": "ap_ntb-043-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" And we won’t learn this language if our minds have become passive thoroughfares for advertising jingles, political slogans, and hashtags.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Hacking at the Branches")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("When we habitually attend to distant news, it’s not just our minds that are damaged; we become less able to feel and act responsibly. In "), _c('i', [_vm._v("Walden")]), _vm._v(", where he also warns readers of the dangers of obsessive news consumption, Thoreau describes this problem by critiquing the recent boom in philanthropic activity: “There are a thousand hacking at the branches of evil to one who is striking at the root, and it may be that he who bestows the largest amount of time and money on the needy is doing the most by his mode of life to produce that misery which he strives in vain to relieve.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-044",
      "id": "ap_ntb-044-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Thoreau’s polemic against the “drastic philanthropy [that] seeks out the Esquimaux and the Patagonian” is famously echoed in fictional form by Charles Dickens’s character Mrs. Jellyby. A minor character in "), _c('i', [_vm._v("Bleak House")]), _vm._v(", Mrs. Jellyby is a “telescopic philanthropist” fixated on helping people in Africa while blithely neglecting her own children."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-045",
      "id": "ap_ntb-045-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" In our twenty-first-century media ecosystem, we are all in danger of becoming Mrs. Jellybys: making the news media the primary lens through which we view the world magnifies the significance of distant, shocking events and obscures the important events happening at hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("News-as-spectacle, whether a political scandal, a natural disaster, a terrorist attack, or almost any story as rendered by television, shapes those who consume it to be passive spectators. As Eitan Hersh explains, summarizing a Pew Research Center study, “Daily news consumers are very interested in "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("politics, so they say, but they aren’t doing much: In 2016 most reported belonging to zero organizations, having attended zero political meetings in the last year, having worked zero times with others to solve a community problem.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-046",
      "id": "ap_ntb-046-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" If we do manage to find some way of acting in response to the latest gripping news event, it tends to be through a kind of dramatic gesture—donating to a celebrity’s foundation or posting a video of someone dumping ice water over us—that aims at distant symptoms rather than nearby causes."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-047",
      "id": "ap_ntb-047-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Yet the stories that fill the news foster the erroneous belief that we have to feel intensely about, and do what we can to address, the most visible and spectacular problems rather than attend to—and tend to—nearby issues. When our experience of the world is filtered through the news media, the tragedies that play out on our screens can seem more pressing than the ones that happen closer to home. In this condition, we risk being like the priest and the Levite, who passed by the wounded man on the side of the road, rather than the Samaritan, who saw, had compassion for, and took action to help his neighbor (Lk 10:25-37).")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As Jesus’ parable indicates, telescopic or misdirected attention, and the disordered love that follows, isn’t a new problem. Nonetheless, improvements in communications technology have increased the temptation to sympathize with distant events and ignore ones nearby. It’s no accident that Thoreau and Dickens addressed this problem in the mid- nineteenth century. Thoreau fingered the telegraph as part of the problem, and he quipped that once the transatlantic tele"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("graph cable was finally laid, “perchance the first news that will leak through into the broad, flapping American ear will be that the Princess Adelaide has the whooping cough.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-048",
      "id": "ap_ntb-048-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Neil Postman agrees with Thoreau that this technology inaugurated many of the problematic dynamics associated with the modern news industry: “Only four years after Morse opened the nation’s first telegraph line on May 24, 1844, the Associated Press was founded, and news from nowhere, addressed to no one in particular, began to crisscross the nation. Wars, crimes, crashes, fires, floods—much of it the social and political equivalent of Adelaide’s whooping cough—became the content of what people called ‘the news of the day.’” Thus Postman claims that the telegraph “dramatically altered what may be called the ‘information-action ratio.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-049",
      "id": "ap_ntb-049-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" By flooding us with information to which we can have no meaningful response, these technologies threaten to malform our affective sensibilities. The goal of a properly attentive life is right love and right action, and this goal is not served when we are caught up in distant dramas.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The contemporary novelist Barbara Kingsolver, in a marvelous essay detailing why she and her family don’t watch TV, describes a conversation she had with a friend about the airplane crash involving John Kennedy Jr. Kingsolver writes that she hadn’t heard the news because she had been “attending only to the news of my own community” for several weeks, and her friend was shocked that she didn’t know about this tragedy. Yet Kingsolver averred that “it would make no real difference in my life”:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("It’s not that I’m callous about the calamities suffered by "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("famous people; they are heartaches, to be sure, but heartaches genuinely experienced only by their own friends and families. It seems somewhat voyeuristic, and also absurd, to expect that JFK Jr.’s death should change my life any more than a recent death in "), _c('i', [_vm._v("my ")]), _vm._v("family affected the Kennedys. . . . On the matter of individual tragic deaths, I believe that those in my own neighborhood are the ones I need to attend to first, by means of casseroles and whatever else I can offer. I also believe it’s possible to be so overtaken and stupefied by the tragedies of the world that we don’t have any time or energy left for those closer to home, the hurts we should take as our own."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-050",
      "id": "ap_ntb-050-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Kingsolver’s attitude here parallels Thoreau’s, and she wisely insists on directing her emotional energy toward people and events to which she can lovingly respond. As Augustine advises, “All people should be loved equally. But you cannot do good to all people equally, so you should take particular thought for those who, as if by lot, happen to be particularly close to you in terms of place, time, or any other circumstances.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-051",
      "id": "ap_ntb-051-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Near the end of Thoreau’s “Life Without Principle,” he stubbornly declares, “I have not got to answer for having read a single President’s Message.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-052",
      "id": "ap_ntb-052-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Yet when the news is filled with breathless analysis of the latest presidential tweet, it makes us imagine that we must somehow respond to every dispatch from the White House. We don’t! What would such a response even look like? In most cases, any imaginable reply would amount to hacking at the branches of the problem while our mode of life—"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("for instance, our own complicity in a news-entertainment complex that profits from politicians who churn out new scandals every hour—perpetuates a spectacle-driven politics. Habitually attending to the trivia of the day macadamizes our intellects, gives us mental dyspepsia, makes us vulnerable to groupthink, and deforms our affective responses. The result of all this is that we are less able to attend to and love our neighbors.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 78
// module chunks = 0